import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-dialog-trial-started',
    templateUrl: './dialog-trial-started.component.html',
    // styleUrls: ['./dialog-trial-started.component.scss'],
    standalone: false,
})
export class DialogTrialStartedComponent implements OnInit {
    @Input() showDialog = false;
    @Output() openModalTryHardwareClicked = new EventEmitter<void>();
    @Output() onHide = new EventEmitter<void>();

    constructor() {}

    ngOnInit(): void {}
}
